import RichText from 'components/ui/ContentBlocks/RichText';
import Slider from './Slider';
import type { Entry } from 'contentful';
import type { ClinicPage } from 'types/Clinic';
import type { IBlockGenericCtaFields } from 'types/contentful/generated';
import type { CtaItem } from 'types/PageData';
import type { Document } from '@contentful/rich-text-types';

type Props = {
  description?: Document;
  headline: string | undefined;
  items: ClinicPage[];
  cta: Entry<IBlockGenericCtaFields>;
};

const Clinics = ({ description, headline, items, cta }: Props): JSX.Element => {
  const sliderItems: (ClinicPage | CtaItem)[] = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item) {
      sliderItems.push(item);
      if ((i + 1) / 3 === 1 || i === items.length - 1) {
        sliderItems.push({
          isCta: true,
          fields: { ...cta.fields },
        });
      }
    }
  }

  return (
    <div className="border-t border-silver-light">
      <div className="max-w-screen-xl mx-auto">
        {headline && (
          <h2 className="text-2-188r lg:text-1-938r mb-2 px-5 lg:px-4 hyphenate">
            {headline}
          </h2>
        )}
        {description && (
          <div className="text-charcoal mb-8 leading-8 md:leading-normal px-5 lg:px-4">
            <RichText fields={description} />
          </div>
        )}
        <div className="pl-3 lg:px-4">
          <Slider type="clinicItem" items={sliderItems} />
        </div>
      </div>
    </div>
  );
};

export default Clinics;
